import { render, staticRenderFns } from "./WithdrawTabNav.vue?vue&type=template&id=eaba98a2"
import script from "./WithdrawTabNav.vue?vue&type=script&lang=js"
export * from "./WithdrawTabNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports